export enum ARSServiceCode {
  CITIZEN_APPEAL_TO_MVS = 'ARS01',
  SEARCH_INCOMING_CORRESPONDENCE = 'ARS02',
}

export enum BIAServiceCode {
  INSURANCE = 'BIA01',
}

export enum ERZServiceCode {
  RESIDENCE_RELOCATION = 'IAC01',
  TEMPORARY_RESIDENCE_RELOCATION = 'IAC02',
  CANCELLATION_TEMPORARY_RESIDENCE_RELOCATION = 'IAC03',
  PURCHASE = 'IBB01',
  COLD_STEEL_STORAGE_FOR_COLLECTION = 'ICS01',
  STORAGE_CARRYING = 'ISC01',
  TRANSPORT_ACROSS_BORDER = 'ITT05',
  COLD_STEEL_TRANSPORTATION = 'ITT06',
  COMMISSION_SALE = 'IVE01',
  VALIDITY_PERIOD_PROLONGATION = 'extension',
  ERZ_EXTRACT = 'erz.extract',
  ERZ_SEARCH = 'erz.search',
  REAPPLICATION = 'reapplication',
}

export enum IACServiceCode {
  CRIMINAL_RECORD_SEARCH = 'CEAA02',
  CRIMINAL_RECORD_SEARCH_ALL = 'CEAA03',
  EXTENDED_CRIMINAL_RECORD_EXTRACT = 'CEAA05',
  EXTRACT_REDELIVERY = 'CEAA06',
}

export enum MSPServiceCode {
  SOCIAL_PROTECT = 'social_protect',
}

export enum PAYServiceCode {
  PAYMENT_WITHOUT_APPLICATION = 'PAY01',
}

export enum RMPServiceCode {
  MISSING_PERSON = 'missingPerson',
  MISSING_PERSON_EXTRACT = 'RMP02',
}

export enum RMPCServiceCode {
  TATTOO_SEARCH = 'RMPTATU',
}

export enum WNTServiceCode {
  MISSING_PASSPORT = 'WNT01',
  WANTED_PERSON_SEARCH = 'WNT02',
  MISSING_PERSON_SEARCH = 'WNT03',
  MISSING_CHILDREN_SEARCH = 'WNT04',
  MISSING_INCAPACITATED_PERSONS = 'WNT05',
  MISSING_CORPSES = 'WNT06',
  MISSING_PHONE = 'WNT07',
  WANTED_WEAPON = 'WNT08',
  WANTED_ART = 'WNT09',
  VEHICLE_SEARCH = 'WNT10',
  CHECK_EXTRACT_VERIFICATION = 'WNT11',
}
